import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";

const css = `
  .notification {
    font-family: Arial, sans-serif;
    font-size: 14px;
  }
  
.notification-error .notification-message::before {
  display: none !important;
}

.notification-success::after,
.notification-info::after,
.notification-warning::after {
  content: "✖";
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 16px;
  font-weight: 500; /* "medium" is not valid for font-weight */
  color: #fff;
  cursor: pointer;
  opacity: 1;
  transition: all 0.2s ease;
}

`;

if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);
}


export const Toast = ({ type, message, duration = 6000 }) => {
  NotificationManager.listNotify.forEach((n) =>
    NotificationManager.remove({ id: n.id })
  );
  switch (type) {
    case "success":
      NotificationManager.success(message, "", duration);
      break;
    case "error":
      NotificationManager.error(message, "", duration);
      break;
    case "info":
      NotificationManager.info(message, "", 6000);
      break;
    case "warning":
      NotificationManager.warning(message, "", 6000);
      break;
    default:
      NotificationManager.info(message, "", 6000);
  }
};
